<div class="w-full h-full relative">
  <div *ngIf="step !== RuleSetsImportStep.DONE" class="flex flex-row justify-end items-center w-full absolute">
    <div class="absolute left-0" *ngIf="step < RuleSetsImportStep.IMPORTING">
      <div class="back-btn clickable flex items-center justify-center back-btn-border" (click)="stepBack()">
        <ui-icon [icon]="'griddy-chevron-left'"></ui-icon>
      </div>
    </div>
    <ui-close [border]="true" (click)="closeModal()"></ui-close>
  </div>
  <div id="wizard-content">
    <ng-container [ngSwitch]="step" *ngIf="(importError$ | async) === false; else errorTemplate">
      <ng-container *ngSwitchCase="RuleSetsImportStep.INITIAL">
        <div class="flex flex-col items-center justify-center">
          <div class="grid sbnbDesktop:grid-cols-2 gap-8">
            <div class="flex flex-col justify-center max-w-lg p-8 gap-8 box-content">
              <div class="flex flex-col gap-6">
                <h2 class="text-2xl font-semibold m-0">Airbnb rule-sets found and ready to import</h2>
                <p class="m-0">
                  We'll import all <strong>{{ airbnbRuleSets.length }} Airbnb rule-sets</strong> into Hospitable. Here's
                  a preview of 3, so you know what's coming.
                </p>
              </div>
              <div class="flex flex-col gap-4">
                <div class="border rounded-md p-3 hover:bg-smoke-lighter" *ngFor="let ruleset of previewRuleSets">
                  <div class="flex gap-3">
                    <div
                      class="w-6 h-6 rounded-full border flex-shrink-0 border-smoke"
                      [class]="'bg-ruleset-' + ruleset.color"></div>
                    <div class="flex flex-col gap-1">
                      <h4>{{ ruleset.title }}</h4>
                      <span class="text-sm text-night line-clamp-2">
                        {{ ruleset.summary }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex gap-4">
                <sbnb-button [type]="'secondary'" label="Go back" (click)="stepBack()"></sbnb-button>
                <sbnb-button label="Learn how it works " (click)="moveForward()"></sbnb-button>
              </div>
            </div>
            <div class="flex-col items-center justify-center hidden sbnbDesktop:flex">
              <img src="/assets/images/rulesets/review.svg" alt="Preview" width="400" />
            </div>
          </div>
        </div>
      </ng-container>
      <div *ngSwitchCase="RuleSetsImportStep.PREVIEW">
        <div class="flex flex-col items-center justify-center">
          <div class="grid sbnbDesktop:grid-cols-2 gap-8">
            <div class="flex flex-col justify-center max-w-lg p-8 gap-8 box-content">
              <h2 class="text-2xl font-semibold m-0">Here's what will happen</h2>
              <ul class="list-disc pl-6 text-night m-0">
                <li class="leading-6">We'll import all your Airbnb rule-sets</li>
                <li class="leading-6">We'll match each rule exactly - same settings, properties, and dates</li>
                <li class="leading-6">We'll clear them from your Airbnb calendar to avoid conflicts</li>
                <li class="leading-6">You'll manage all rule-set edits directly from Hospitable</li>
              </ul>
              <div class="flex gap-3 text-sm">
                Learn more
                <a
                  href="https://help.hospitable.com/en/articles/11507973-rule-sets-overview"
                  target="_blank"
                  class="underline text-raspberry-darker text-sm"
                  ><strong>Hospitable rule-sets</strong></a
                >
                <a
                  href="https://help.hospitable.com/en/articles/11508315-rule-sets-and-airbnb"
                  target="_blank"
                  class="underline text-raspberry-darker text-sm"
                  ><strong>Airbnb rule-sets</strong></a
                >
              </div>
              <div class="flex gap-4">
                <sbnb-button [type]="'secondary'" label="Go back" (click)="stepBack()"></sbnb-button>
                <sbnb-button label="Import and switch" (click)="optIn(true)"></sbnb-button>
              </div>
              <div
                type="button"
                class="underline text-black cursor-pointer"
                (click)="$event.preventDefault(); optIn(false)"
                ><strong>Skip importing and start fresh</strong></div
              >
            </div>
            <div class="flex-col items-center justify-center hidden sbnbDesktop:flex">
              <img src="/assets/images/rulesets/what-happens.svg" alt="Info" width="400" />
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngSwitchCase="RuleSetsImportStep.IMPORTING">
        <div class="flex flex-col items-center justify-center">
          <img src="/assets/images/rulesets/trumpet.png" alt="Importing rule-sets" width="238" />
          <div class="information-card">
            <ul class="p-0 m-0">
              <ng-container *ngFor="let step of rulesetsImportSteps; let i = index">
                <li class="flex gap-4 py-2" [class.hidden]="(importProgress$ | async) < i + 1">
                  <ui-loading-spinner [size]="16" *ngIf="(importProgress$ | async) === i + 1"></ui-loading-spinner>
                  <ui-icon *ngIf="(importProgress$ | async) > i + 1" [icon]="step.icon" [size]="16"></ui-icon>
                  <div class="flex-1">{{ step.description }}</div>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="RuleSetsImportStep.DONE">
        <div class="flex flex-col items-center justify-center">
          <img src="/assets/images/rulesets/trumpet.png" alt="Importing rule-sets" width="238" />
          <div class="information-card">
            <div class="done-container grid gap-2 items-center justify-center text-center">
              <ui-icon [icon]="'check'" [size]="40" [classes]="'text-success-500'"></ui-icon>
              <h3 class="m-0">Rule-sets are now in Hospitable</h3>
              <p class="mt-0 mb-1 text-night text-sm"> You'll manage all rule-sets directly from Hospitable. </p>
              <sbnb-button
                class="text-sm"
                [fullWidth]="true"
                [type]="'secondary'"
                [label]="'Back to calendar'"
                (click)="closeModal(true)"></sbnb-button>
            </div>
          </div>
        </div>
      </ng-container>
      <div *ngSwitchDefault></div>
    </ng-container>
    <ng-template #errorTemplate>
      <div class="flex flex-col items-center justify-center">
        <div class="grid sbnbDesktop:grid-cols-2 gap-8">
          <div class="flex flex-col justify-center max-w-lg p-8 gap-8 box-content">
            <div class="flex flex-col gap-6">
              <h2 class="text-2xl font-semibold m-0">We couldn't import your rule-sets</h2>
              <p class="m-0">
                There was a problem importing your Airbnb rule-sets. This isn't something you can fix on your end. we've
                flagged it for our team, and an engineer will take a look shortly.
              </p>
              <p class="m-0"> If you have any questions in the meantime, feel free to contact us </p>
            </div>
            <div class="grid grid-cols-2 gap-4">
              <sbnb-button [fullWidth]="true" [type]="'secondary'" label="Go back" (click)="closeModal()"></sbnb-button>
              <sbnb-button [fullWidth]="true" label="Contact support" (click)="contactSupport()"></sbnb-button>
            </div>
          </div>
          <div class="flex-col items-center justify-center hidden sbnbDesktop:flex">
            <img src="/assets/images/rulesets/error.png" alt="Preview" width="400" />
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
